interface RecordingPlayerProps {
  url: string;
}

export function RecordingPlayer({ url }: RecordingPlayerProps): React.ReactNode {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <audio controls className="w-full" src={url}>
        <track kind="captions" />
      </audio>
    </div>
  );
}
